export default __webpack_public_path__ + "static/media/gmx-logo-final.0b59e423.png";